import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { Router } from '@angular/router';
import { Data } from "./data";

@Component({
    selector: 'app-couponcode',
    templateUrl: './branchinfo.component.html',
  providers: [ SharedService,PopupSegmentComponent]
 
})
export class BranchInfoComponent implements OnInit {
isAllCompaniesAllowed : any;
data=[];
i=1;
name : '';
page : number =1;
itemsTotalAdv : number =0;
objLoaderStatus: boolean = false;
errormessage = '';
charFlag :boolean = false;
userId : number;
searchmessage = "";
companies =[];
coupon =[];
companyFlag : boolean;
user = [];
companiesSelected =[];
branchFlag : any;
companySelected = {"id":'',"name":''};
branchData = [{"branchCompanyModel":{"branchFlag":false,"userBaseModel":{}},"userBaseModel":{}}];
companyData = [];
branches =[];
radioselected : any;
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
    private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService,
    private router: Router,
    private dataCompany: Data,
) {

    
    }

    ngOnInit() {
      var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
       this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
this.localstorage.setStorage("country",'');
 if(this.dataCompany.storage && this.dataCompany.storage.isAllCompaniesAllowed){
this.isAllCompaniesAllowed = this.dataCompany.storage.isAllCompaniesAllowed;
 }
  
  if(this.dataCompany.storage && this.dataCompany.storage.radioselected == false){
this.radioselected = this.dataCompany.storage.radioselected;
 }

  if(this.dataCompany.storage && this.dataCompany.storage.companyData){
this.companyData = this.dataCompany.storage.companyData;
 }

  if(this.dataCompany.storage && this.dataCompany.storage.branchData){
this.branchData = this.dataCompany.storage.branchData;
 }


  if(this.dataCompany.storage && this.dataCompany.storage.name){
this.name = this.dataCompany.storage.name;
 }

 console.log(this.companyData);
  console.log(this.branchData);

localStorage.setItem("user",JSON.stringify(this.user));
       var i=0;
       var j=0;
        var token = this.localstorage.getStorage("token");
         this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/searchAdvertisersByCompanyName?q="+this.name+"&currentPage=1&currentSize=10", null, token).subscribe((result) => {
 console.log(result.data)
if(result.data && result.data.length>0){
    this.data = result.data;
       this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
}
else{

}
  this.loaderService.displayLoader(false);

     });
       
 
    }

nextBranch(event){
   this.itemsTotalAdv =0;
    var j=0;
    var i=0;
    this.page = event;
    var token = this.localstorage.getStorage("token");
         this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/searchAdvertisersByCompanyName?q="+this.name+"&currentPage="+event+"&currentSize=10", null, token).subscribe((result) => {
 console.log(result.data)
if(result.data && result.data.length>0){
    this.data = result.data;
       this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
}
else{

}
  this.loaderService.displayLoader(false);

         });
       
  
    return event; 
    
}



}



// WEBPACK FOOTER //
// ./src/app/admin/layout/couponCode/branchinfo.component.ts